const selectors = {
    container: '.js-wkrTemplateNotificationContainer'
};

export default class WkrTemplateNotification {

    private readonly container: JQuery;

    constructor() {
        this.container = $(selectors.container);
        this.displayBanners();
    }

    static initAll(): WkrTemplateNotification {
        return new WkrTemplateNotification();
    }

    private displayBanners(): void {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        WkrTemplateNotification.getBanners()
            .done((data: string) => {
                if (data) {
                    this.container.append(
                        $(`<div class="alert alert-warning mb-15">${data}</div>`)
                    );
                }
            })
            .fail((err) => {
                // eslint-disable-next-line no-console
                console.log(err);
            });
    }

    private static getBanners(): JQuery.jqXHR {
        return $.ajax({
            url: `${window.ACC.config.encodedContextPath}/wkrTemplate/count`,
            method: 'GET'
        });
    }
}
